<template>
  <div class="personal-articles">
    <div
      v-for="(item, index) in articleList"
      :key="index"
      class="personal-articles-card"
    >
      <div class="personal-articles-card-header">
        <div class="personal-articles-card-title">
          <a
            v-if="['commented', 'favorite', 'like','published'].includes(tab)"
            :href="'/zp/a/' + (item.newsCode || '')"
            target="_blank"
            rel="noopener noreferrer"
            class="personal-articles-title-link"
          >{{ item.title }}</a>
          <span v-else>{{ item.title }}</span>
        </div>
        <div
          v-if="statusText"
          class="personal-articles-status-tag"
          :class="'personal-articles-status-tag--' + tab"
        >
          {{ statusText }}
        </div>
      </div>
      <div class="personal-articles-card-body">
        <div class="personal-articles-card-summary">
          <span>{{ item.summary }}</span>
        </div>
        <div class="personal-articles-card-info">
          <div class="personal-articles-card-left">
            <span
              v-if="tab === 'published' && item.categoryName"
              class="personal-articles-card-channel"
              :style="{ background: item.categoryColor || '#23B4DC' }"
            >
              {{ item.categoryName }}
            </span>
            <span class="personal-articles-card-source">来源：{{ item.source || item.author || '-' }}</span>
          </div>
          <div
            v-if="tab === 'published'"
            class="personal-articles-card-stats"
          >
            点赞&nbsp;{{ item.likeCount || 0 }}&nbsp;&nbsp;
            收藏&nbsp;{{ item.favoriteCount || 0 }}&nbsp;&nbsp;
            留言&nbsp;{{ item.commentCount || 0 }}
          </div>
          <span class="personal-articles-card-date">{{ item.date }}</span>
        </div>

        <!-- 我留言的文章：显示评论内容和时间 -->
        <div v-if="tab === 'commented'" class="personal-articles-extra-info">
          <div class="personal-articles-extra-row">
            <span class="personal-articles-extra-label">我的留言：</span>
            <span class="personal-articles-extra-value">{{ item.myContent || '-' }}</span>
          </div>
          <div class="personal-articles-extra-row">
            <span class="personal-articles-extra-label">留言时间：</span>
            <span class="personal-articles-extra-value">{{ item.updateTime || '-' }}</span>
          </div>
          <div class="personal-articles-extra-actions">
            <span class="personal-articles-action-btn personal-articles-action-btn--danger" @click="handleDeleteComment(item)">删除</span>
          </div>
        </div>

        <!-- 我收藏的文章 -->
        <div v-if="tab === 'favorite'" class="personal-articles-extra-info">
          <div class="personal-articles-extra-row">
            <span class="personal-articles-extra-label">收藏时间：</span>
            <span class="personal-articles-extra-value">{{ item.updateTime || '-' }}</span>
          </div>
          <div class="personal-articles-extra-actions">
            <span class="personal-articles-action-btn personal-articles-action-btn--danger" @click="handleCancelFavorite(item)">取消收藏</span>
          </div>
        </div>

        <!-- 我点赞的文章 -->
        <div v-if="tab === 'like'" class="personal-articles-extra-info">
          <div class="personal-articles-extra-row">
            <span class="personal-articles-extra-label">点赞时间：</span>
            <span class="personal-articles-extra-value">{{ item.updateTime || '-' }}</span>
          </div>
          <div class="personal-articles-extra-actions">
            <span class="personal-articles-action-btn personal-articles-action-btn--danger" @click="handleCancelLike(item)">取消点赞</span>
          </div>
        </div>

        <!-- 已驳回 -->
        <div v-if="tab === 'rejected'" class="personal-articles-reject-info">
          <div class="personal-articles-reject-reason">
            驳回原因：{{ item.approvalReason || '-' }}
          </div>
          <div class="personal-articles-reject-time">
            驳回时间：{{ item.approvalTime || '-' }}
          </div>
          <div class="personal-articles-reject-actions">
            <span class="personal-articles-edit-btn" @click="handleEdit(item)">编辑</span>
          </div>
        </div>
      </div>
    </div>

    <div v-if="articleList.length === 0" class="personal-articles-empty">
      <div class="personal-articles-empty-icon" />
      <div class="personal-articles-empty-text">暂无相关文章</div>
    </div>

    <!-- 分页加载 -->
    <div v-if="articleList.length > 0" class="personal-articles-load-more">
      <span
        v-if="hasMore"
        class="personal-articles-load-btn"
        :class="{ 'is-loading': loadingMore }"
        @click="loadMore"
      >{{ loadingMore ? '加载中...' : '查看更多' }}</span>
      <span v-else class="personal-articles-load-done">已经加载完成全部数据</span>
    </div>
  </div>
</template>

<script>
import { Toast } from 'vant'
import { fetchMyNewsList, fetchMemberList, deleteComment, cancelFavorite, cancelLike } from '../../api'

export default {
  name: 'MyArticles',
  props: {
    tab: {
      type: String,
      default: 'pending'
    }
  },
  data() {
    return {
      userType: localStorage.getItem('userType') || 'personal',
      articleList: [],
      pageNum: 1,
      pageSize: 10,
      hasMore: true,
      loadingMore: false
    }
  },
  computed: {
    queryStatus() {
      const map = {
        pending: 1,
        rejected: 2,
        published: 3
      }
      return map[this.tab] || 1
    },
    statusText() {
      const map = {
        pending: '审核中',
        rejected: '已驳回',
        published: '已发布'
      }
      return map[this.tab] || ''
    }
  },
  watch: {
    tab() {
      this.pageNum = 1
      this.articleList = []
      this.hasMore = true
      this.getArticleList()
    }
  },
  mounted() {
    this.getArticleList()
  },
  methods: {
    async getArticleList(append) {
      if (this.tab === 'magazine') {
        if (!append) this.articleList = []
        this.hasMore = false
        this.$emit('loaded')
        return
      }
      const apiType = this.getApiType()
      if (!apiType) {
        if (!append) this.articleList = []
        this.hasMore = false
        this.$emit('loaded')
        return
      }
      try {
        let result
        if (['pending', 'rejected', 'published'].includes(this.tab)) {
          result = await this.getMyNewsList()
        } else {
          result = await this.getMemberList(apiType)
        }
        if (append) {
          this.articleList = this.articleList.concat(result.list)
        } else {
          this.articleList = result.list
        }
        this.hasMore = result.hasMore
        this.$emit('loaded')
      } catch (err) {
        Toast(err.message || '获取文章列表失败')
        this.$emit('load-error')
      }
    },
    loadMore() {
      if (this.loadingMore || !this.hasMore) return
      this.loadingMore = true
      this.pageNum++
      this.getArticleList(true).finally(() => {
        this.loadingMore = false
      })
    },
    getApiType() {
      const map = {
        pending: 'news',
        rejected: 'news',
        published: 'news',
        commented: 'comment',
        favorite: 'favorite',
        like: 'like'
      }
      return map[this.tab] || null
    },
    async getMyNewsList() {
      const result = await fetchMyNewsList(
        { queryStatus: this.queryStatus, pageNum: this.pageNum, pageSize: this.pageSize },
        this.userType
      )
      const records = result.records || []
      const totalPages = result.pages || 1
      const list = records.map(item => {
        let date = ''
        if (this.tab === 'published') {
          date = item.publishTime || ''
        } else {
          date = item.createTime || ''
        }
        return {
          id: item.id,
          newsId: item.id,
          newsCode: item.newsCode || item.id,
          title: item.title || '',
          summary: item.summary || '',
          author: item.author || '',
          source: item.source || '',
          categoryName: item.categoryName || '',
          categoryColor: item.categoryColor || '',
          likeCount: item.likeCount || 0,
          favoriteCount: item.favoriteCount || 0,
          commentCount: item.commentCount || 0,
          approvalReason: item.approvalReason || '',
          approvalTime: item.approvalTime || '',
          date
        }
      })
      return { list, hasMore: this.pageNum < totalPages }
    },
    async getMemberList(apiType) {
      const result = await fetchMemberList(apiType, { pageNum: this.pageNum, pageSize: this.pageSize })
      const records = result.records || []
      const totalPages = result.pages || 1
      const list = records.map(item => {
        return {
          id: item.id,
          newsId: item.newsId,
          newsCode: item.newsCode || item.newsId,
          title: item.title || '',
          summary: item.summary || '',
          source: item.source || '',
          author: item.source || '',
          coverImage: item.coverImage || '',
          likeCount: item.likeCount || 0,
          favoriteCount: item.favoriteCount || 0,
          commentCount: item.commentCount || 0,
          myContent: item.content || '',
          updateTime: item.updateTime || '',
          date: item.publishTime || ''
        }
      })
      return { list, hasMore: this.pageNum < totalPages }
    },
    handleEdit(item) {
      this.$emit('edit', item)
    },
    async handleDeleteComment(item) {
      if (!item.id) {
        return
      }
      try {
        await deleteComment(item.id)
        Toast('删除成功')
        this.pageNum = 1
        this.articleList = []
        this.hasMore = true
        this.getArticleList()
        this.$emit('refresh')
      } catch (err) {
        Toast(err.message || '删除失败')
      }
    },
    async handleCancelFavorite(item) {
      if (!item.newsId) {
        return
      }
      try {
        await cancelFavorite(item.newsId)
        Toast('取消收藏成功')
        this.pageNum = 1
        this.articleList = []
        this.hasMore = true
        this.getArticleList()
        this.$emit('refresh')
      } catch (err) {
        Toast(err.message || '取消收藏失败')
      }
    },
    async handleCancelLike(item) {
      if (!item.newsId) {
        return
      }
      try {
        await cancelLike(item.newsId)
        Toast('取消点赞成功')
        this.pageNum = 1
        this.articleList = []
        this.hasMore = true
        this.getArticleList()
        this.$emit('refresh')
      } catch (err) {
        Toast(err.message || '取消点赞失败')
      }
    }
  }
}
</script>

<style scoped>
.personal-articles {
  padding: 16px;
}

.personal-articles-card {
  background: #FFFFFF;
  border-radius: 8px;
  padding: 20px;
  margin-bottom: 16px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
}

.personal-articles-card-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 12px;
}

.personal-articles-card-title {
  flex: 1;
  font-size: 16px;
  font-weight: 600;
  color: #333333;
  line-height: 1.5;
}

.personal-articles-title-link {
  color: #333333;
  text-decoration: none;
  cursor: pointer;
  transition: color 0.2s ease;
}

.personal-articles-title-link:hover {
  color: #0084E7;
}

.personal-articles-status-tag {
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 24px;
  padding: 0 10px;
  border-radius: 12px;
  font-size: 12px;
  color: #FFFFFF;
}

.personal-articles-status-tag--pending {
  background: #FAAD14;
}

.personal-articles-status-tag--rejected {
  background: #FF4D4F;
}

.personal-articles-status-tag--published {
  background: #52C41A;
}

.personal-articles-card-body {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.personal-articles-card-summary {
  font-size: 14px;
  color: #666666;
  line-height: 1.6;
}

.personal-articles-card-info {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  font-size: 13px;
  color: #999999;
  flex-wrap: wrap;
}

.personal-articles-card-left {
  display: flex;
  align-items: center;
  gap: 10px;
}

.personal-articles-card-channel {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 22px;
  padding: 0 10px;
  border-radius: 11px;
  font-size: 12px;
  color: #FFFFFF;
}

.personal-articles-card-source {
  color: #999999;
}

.personal-articles-card-stats {
  color: #999999;
}

.personal-articles-card-date {
  color: #999999;
  margin-left: auto;
}

.personal-articles-extra-info {
  margin-top: 8px;
  padding: 12px;
  background: #F5F7FA;
  border: 1px solid #E8E8E8;
  border-radius: 4px;
  font-size: 13px;
  color: #666666;
  line-height: 1.6;
}

.personal-articles-extra-row {
  margin-bottom: 6px;
}

.personal-articles-extra-row:last-child {
  margin-bottom: 0;
}

.personal-articles-extra-label {
  color: #999999;
}

.personal-articles-extra-actions {
  display: flex;
  justify-content: flex-end;
  margin-top: 10px;
}

.personal-articles-action-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 28px;
  padding: 0 18px;
  font-size: 12px;
  border-radius: 14px;
  cursor: pointer;
  transition: opacity 0.2s ease;
}

.personal-articles-action-btn--danger {
  background: #FF4D4F;
  color: #FFFFFF;
}

.personal-articles-action-btn:hover {
  opacity: 0.85;
}

.personal-articles-reject-info {
  margin-top: 8px;
  padding: 12px;
  background: #FFF1F0;
  border: 1px solid #FFCCC7;
  border-radius: 4px;
  font-size: 13px;
  color: #FF4D4F;
  line-height: 1.6;
}

.personal-articles-reject-actions {
  display: flex;
  justify-content: flex-end;
  margin-top: 10px;
}

.personal-articles-edit-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 28px;
  padding: 0 18px;
  background: #0084E7;
  color: #FFFFFF;
  font-size: 12px;
  border-radius: 14px;
  cursor: pointer;
  transition: opacity 0.2s ease;
}

.personal-articles-edit-btn:hover {
  opacity: 0.85;
}

.personal-articles-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 80px 20px;
}

.personal-articles-empty-icon {
  width: 120px;
  height: 80px;
  background: #E8E8E8;
  border-radius: 4px;
  margin-bottom: 16px;
  position: relative;
}

.personal-articles-empty-icon::before {
  content: '';
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 40px;
  height: 32px;
  background: #D9D9D9;
  border-radius: 2px;
}

.personal-articles-empty-icon::after {
  content: '';
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 20px;
  height: 2px;
  background: #FFFFFF;
  border-radius: 1px;
}

.personal-articles-empty-text {
  font-size: 14px;
  color: #999999;
}

.personal-articles-load-more {
  display: flex;
  justify-content: center;
  padding: 20px 0 10px;
}

.personal-articles-load-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 36px;
  padding: 0 32px;
  border: 1px solid #DCDEE0;
  border-radius: 18px;
  font-size: 14px;
  color: #323233;
  cursor: pointer;
  transition: all 0.2s ease;
}

.personal-articles-load-btn:hover {
  color: #0084E7;
  border-color: #0084E7;
}

.personal-articles-load-btn.is-loading {
  color: #999999;
  cursor: default;
  border-color: #EBEDF0;
}

.personal-articles-load-done {
  font-size: 13px;
  color: #C8C9CC;
}
</style>
